import { useRef, useEffect } from 'react'

const MILLISECONDS_IN_SECOND = 1000

const useVisibleTimeTracker = () => {
  const lastVisibleStart = useRef<number | null>(null)
  const totalVisible = useRef<number | null>(0)
  const running = useRef(false)

  useEffect(() => {
    const onVisibilityChange = () => {
      if (!running.current) return

      if (
        document.visibilityState === 'hidden' &&
        lastVisibleStart.current != null &&
        totalVisible.current != null
      ) {
        totalVisible.current += Date.now() - lastVisibleStart.current
        lastVisibleStart.current = null

        return
      }

      if (document.visibilityState === 'visible' && lastVisibleStart.current == null) {
        lastVisibleStart.current = Date.now()
      }
    }

    document.addEventListener('visibilitychange', onVisibilityChange)

    return () => {
      document.removeEventListener('visibilitychange', onVisibilityChange)
    }
  }, [])

  const startTimingVisible = () => {
    running.current = true
    lastVisibleStart.current = Date.now()
    totalVisible.current = 0
  }

  const stopAndGetVisibleSeconds = () => {
    running.current = false

    if (totalVisible.current == null) return 0

    if (lastVisibleStart.current == null) {
      return totalVisible.current / MILLISECONDS_IN_SECOND
    }

    totalVisible.current += Date.now() - lastVisibleStart.current
    lastVisibleStart.current = null

    return totalVisible.current / MILLISECONDS_IN_SECOND
  }

  return { startTimingVisible, stopAndGetVisibleSeconds }
}

export default useVisibleTimeTracker
